var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_1990)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58593 1.79329C9.60583 1.79329 9.62573 1.79329 9.64564 1.79329C11.8513 1.79329 13.9315 2.68488 15.5097 4.30588C17.1078 5.94778 17.9959 8.13698 18.0119 10.47C18.0462 15.2897 14.3191 19.2387 9.70335 19.2725C7.48181 19.2934 5.37272 18.3983 3.78008 16.7614C2.18296 15.12 1.29385 12.9298 1.27743 10.5944C1.24459 5.77563 4.9722 1.82762 9.58593 1.79329ZM9.64017 20.1825C9.66356 20.1825 9.68744 20.1825 9.71082 20.182C14.8271 20.1447 18.9592 15.7852 18.9214 10.4635C18.905 7.89418 17.9243 5.48258 16.162 3.67151C14.3947 1.85548 12.0528 0.866361 9.57896 0.884272C4.4642 0.921588 0.331593 5.28008 0.367913 10.6008C0.385825 13.1721 1.36649 15.5852 3.12829 17.3963C4.87866 19.1949 7.18877 20.1825 9.64017 20.1825Z",
    fill: "#2E7161"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0858 9.18438L4.45029 7.60189L6.54344 5.43861L9.66606 8.46L12.8137 5.20688L14.8633 7.19L11.7156 10.4431L14.8386 13.4649L12.7455 15.6281L9.62248 12.6064L6.47343 15.861L4.42386 13.8778L7.57291 10.6233L6.0858 9.18438ZM3.13744 13.8994L6.49463 17.1477L9.64369 13.8932L12.7667 16.9149L16.1257 13.4433L13.0027 10.4216L16.1497 7.16916L12.7925 3.9208L9.64556 7.17322L6.52294 4.15183L3.16388 7.62343L6.2865 10.6448L3.13744 13.8994Z",
    fill: "#2E7161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_1990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4043,
    height: 19.4043,
    fill: "white",
    transform: "translate(0 0.808594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a80c6f33a6f4dff45f28fa9f62dafdf8.svg";
export { ForwardRef as ReactComponent };